module.exports = __webpack_public_path__ + "media/images/new_home/Intersect-763ba59c1ef4b4ffc0cb93f9c7f50f1c.png";